import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css'

const ScrollManager = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname !== '/') return;

        const lenis = new Lenis({
            duration: 3.0, // Very slow, cinematic scroll
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical', 
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 0.4, // Drastically reduce scroll sensitivity
            smoothTouch: false,
            touchMultiplier: 2,
        });

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);

        return () => {
            lenis.destroy();
        };
    }, [pathname]);

    return null; // This component handles side effects only
};

export default ScrollManager;
